import React, { Component, Fragment } from "react";
import classes from "./Posts.css";

import CreatePost from "./CreatePost/CreatePost";
import LoadingPost from "./LoadingPost/LoadingPost";
import Post from "./Post/Post";

import Modal from "../UI/Modal/Modal";
class Posts extends Component {
  state = {
    posts: [],
    viewPosts: [],
    users: [],
    selectedUser: null,
    showUserDetails: false,
    loading: false,
    last: 0
  };

  createPost = post => {
    alert(`${post.title}, ${post.content}`);
  };

  showUser = id => {
    this.setState(prev => {
      prev.selectedUser = this.state.users.filter(user => user.id === id)[0];
      prev.showUserDetails = true;
      return prev;
    });
  };

  componentDidMount() {
    fetch("https://jsonplaceholder.typicode.com/posts")
      .then(res => res.json())
      .then(posts => {
        fetch("https://jsonplaceholder.typicode.com/users")
          .then(userRes => userRes.json())
          .then(users => {
            this.setState(prev => {
              prev.posts = posts.map(p => {
                users.forEach(user => {
                  if (user.id === p.userId) {
                    p["user_name"] = user.name;
                    p["user_id"] = user.id;
                  }
                });
                return p;
              });
              prev.users = users;
              prev.last = 5;

              prev.viewPosts = prev.posts.map((post, i) =>
                i < prev.last ? (
                  <Post
                    key={post.id}
                    user={post.user_name}
                    title={post.title}
                    content={post.body}
                    showUser={this.showUser}
                    userID={post.user_id}
                  />
                ) : null
              );
              return prev;
            });
          });
      });
  }

  renderViewUsers = last => {
    if (last < this.state.posts.length) {
      this.setState(prev => {
        prev.last = last;
        prev.viewPosts = this.state.posts.map((post, i) =>
          i < last ? (
            <Post
              key={post.id}
              user={post.user_name}
              title={post.title}
              content={post.body}
              showUser={this.showUser}
              userID={post.user_id}
            />
          ) : null
        );
        return prev;
      });
    }
  };

  componentDidUpdate() {
    if (this.state.loading) {
      let last = this.state.last + 5;
      fetch("https://jsonplaceholder.typicode.com/posts")
        .then(res => res.json())
        .then(posts => {
          fetch("https://jsonplaceholder.typicode.com/users")
            .then(userRes => userRes.json())
            .then(users => {
              this.setState(prev => {
                prev.posts = posts.map(p => {
                  users.forEach(user => {
                    if (user.id === p.userId) {
                      p["user_name"] = user.name;
                      p["user_id"] = user.id;
                    }
                  });
                  return p;
                });
                prev.users = users;
                prev.loading = false;
                return prev;
              });
              this.renderViewUsers(last);
            });
        });
    }
  }

  isInViewport = () => {
    if (!this.state.loading) {
      this.setState(prev => {
        prev.loading = true;
        return prev;
      });
    }
  };

  render() {
    return (
      <Fragment>
        <Modal
          show={this.state.showUserDetails}
          onCloseModal={() => this.setState({ showUserDetails: false })}
        >
          {JSON.stringify(this.state.selectedUser)}
        </Modal>
        <div className={classes.Posts}>
          <CreatePost createPost={this.createPost} />
          {this.state.viewPosts}
          <LoadingPost nextPosts={this.isInViewport} />
        </div>
      </Fragment>
    );
  }
}

export default Posts;
